import { Switch } from "@centricsoftware/design-system";
import clsx from "clsx";
import { DialogComponent, WaitOverlay } from "csi/components/index";
import DojoView from "csi/page/DojoView";
import { useStore } from "csi/state/hooks";
import { Box, FlexColumn, FlexRowCenter, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useFormDefinitionStore } from "./FormDefinitionStore";
import css from "./FormPreview.module.css";
import { SelectableFormFields } from "./SelectableFormFields";

const CREATE_FORM_DEFINITION = "CreateFormDefinition";

export const FormPreview: FunctionComponent = observer(function FormPreview() {
	const {
		isMigrationInProgress,
		isNewFormBuilder,
		setShowSwitchingToClassicFormBuilderWarningDialog,
		showSwitchingToClassicFormBuilderWarningDialog,
		switchBackToClassicFormBuilder,
		toggleClassicFormBuilder,
	} = useFormDefinitionStore();
	const { routerStore } = useStore();
	const { locationNode } = routerStore;
	const onCloseSwitchDialog = () => setShowSwitchingToClassicFormBuilderWarningDialog(false);
	const onActionSwitchDialog = () => switchBackToClassicFormBuilder();

	return (
		<FlexColumn className={clsx(isNewFormBuilder && css.newFormBackground)}>
			<WaitOverlay show={isMigrationInProgress} />
			<FlexRowCenter className={css.classicFormBanner}>
				<FlexRowCenter gap={2}>
					<Switch checked={isNewFormBuilder} onChange={toggleClassicFormBuilder} />
					<Text res="FormBuilderFormDefinitionSwitchToNew" />
				</FlexRowCenter>
			</FlexRowCenter>
			{!isNewFormBuilder ? (
				<Box p={2}>
					<DojoView
						nodeUrl={locationNode.CreateFormDefinition}
						viewId={CREATE_FORM_DEFINITION}
						viewNodeType={CREATE_FORM_DEFINITION}
					/>
				</Box>
			) : (
				<SelectableFormFields />
			)}
			{showSwitchingToClassicFormBuilderWarningDialog && (
				<DialogComponent
					category="error"
					dataCsiAutomation="IsNewFormBuilderActionId"
					messageRes="IsNewFormBuilderActionId_Message"
					onAction={onActionSwitchDialog}
					onClose={onCloseSwitchDialog}
					open
					titleRes={{ res: "IsNewFormBuilderActionId_Title" }}
				/>
			)}
		</FlexColumn>
	);
});
